import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { reviewDetailsModel } from '../../models/reviews.models'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ReviewStatusEnum } from '../../models/reviews.enum'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-review-details',
	templateUrl: './review-details.component.html',
	styleUrl: './review-details.component.scss',
})
export class ReviewDetailsComponent {
	ReviewStatusEnum = this.SharedService.returnEnumArray(ReviewStatusEnum)
	attachmentLink = environment.attachmentPath
	constructor(
		private SharedService: SharedService,
		public dialog: MatDialogRef<ReviewDetailsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: reviewDetailsModel
	) {}
	ngOnInit() {
		console.log(this.data)
	}
	closeDialog() {
		this.dialog.close()
	}

	changeStatus(status: number) {
		let body = {
			status: status,
			reviewId: this.data?.id,
			countryId: this.data.countryId,
		}
		this.dialog.close(body)
	}
}
